<template>
  <div class="btn-group btn-group-sm">
    <button v-if="parseInt(row.client_deals_quantity) < parseInt(row.total_quantity)" class="btn" :class="row.deleted_at?'btn-cancelled':(row.approved_by?'btn-completed':'btn-danger')" :title="row.deleted_at?'Cancelled Deal':'Create Client Deal'" @click="row.deleted_at?'':showModal('create')"><i :class="row.deleted_at?'fa fa-times-circle':'fa fa-check-circle'"></i>{{row.deleted_at?'Cancelled':(can_access('deal_approve','modify')?'Create Client Deal':'Draft Deal')}}</button>

    <b-modal ref="edit-deal-out" :title="(action=='approve'?'Approve':'Add')+' Deal'" size="xl" hide-footer v-if="can_access('deal_approve','view')">
      <AddDealForm :rows="rowData" :forceRerender="tradeFormReRender"/>
    </b-modal>
  </div>
</template>
<script>
import $ from 'jquery';
import DealInvoice from '@/components/Accounts/DealInvoice';
import common from '@/assets/js/common.js';
export default {
  props: ['row', 'nested','refresh'],
  mixins: [common],
  data(){
    return {
      show: 1,
      rowData:{},
      action:''
    }
  },
  components: { AddDealForm: () => import('@/components/Accounts/AddDealForm'),DealInvoice },
  mounted () {
    //$(this.$el).find('button[title]').tooltip()
  },
  computed: {
    isDisplayRowVisible () {
      if (this.nested.comp !== 'SubTrades') return
      return this.nested.visible
    },
  },
  methods: {
    tradeFormReRender(response) {
      if(response.code==0){
        this.$refs['edit-deal-out'].hide();
        this.show = 1;
        this.refresh();
        this.$toasted.success("Successfully Added",{duration:1000});
      }
    },
    toggleNestedComp (comp) {
      const { nested } = this
      if (nested.comp === comp) return nested.$toggle()
      nested.$toggle(comp, true)
    },
    showModal(action) {
      if(parseInt(this.row.client_deals_quantity) < parseInt(this.row.total_quantity)){
        this.action = action;
        if(action == 'create'){
          this.rowData = this.duplicate(this.row);
          this.rowData.action = 'create'
          this.rowData.id = '';
        }
        this.$refs['edit-deal-out'].show()
      }else{
        this.$toasted.info("You can not do this action in overall ticket",{duration:1500});
      }
    },
  }
}
</script>
<style>
.-nested-comp-open-btn {
  color: #fff !important;
  background-color: #337ab7 !important;
}
dd, dt {
    line-height: 1.42857143;
}
</style>
